import React, { useEffect } from "react";
import { Input, Slider } from "xsolla-uikit";
import { ProductContext } from '../context';







export default function StoreSbSize({
  blockOrder = 0,
  handleSize = (newColor)=>{void(0)}
}) {

  const [state, setState] = React.useState({
      background: '#fff',
      cardWidth: 300,
  })

  const valueFromContext = React.useContext(ProductContext);


  const changeTheme = valueFromContext.changeTheme;

  let oldTheme;

  useEffect(() => {
    // if (!oldTheme && valueFromContext) oldTheme = valueFromContext.getTheme();
  }, [valueFromContext])

  const changeCardSize = (newSize) => {
    setState({
      ...state,
      cardWidth: newSize
    })

    let newSections = [...valueFromContext['sections']];
    newSections[blockOrder]['cardWidth'] = newSize;
    valueFromContext.setStateFrom(
      'sections', newSections
    )

    // valueFromContext.changeCardSize(newSize)
  };

  return (
    <div style = {{display: 'flex',  width: '100%', height: 36, alignItems:'center'}}>

      <div style = {{flexGrow: 1, }}>
        <Slider
          min={136}
          max={600}
          key={state}
          // size='sm'
          // focused= {(!index) ?  true : false}
          input={{
            name: `Size`,
            value: state.cardWidth,
            onChange: changeCardSize,
        }} />
      </div>

      {/* <input
        type="range" min="200" max="600"
        value={state.cardWidth}
        onChange = {(e)=> {
          changeCardSize(e.target.value)
        }}
       /> */}
       <div style = {{width: 32, marginTop: 0, marginLeft: 8, overflow: 'hidden', lineHeight: '1em' }}>
          {/* <Input
            disabled
            size='xs'
            // focused= {(!index) ?  true : false}
            input={{
              name: `size`,
              value: state['cardWidth'] || '',
              // onChange: this.setValueGeneralName
              onChange: ()=>void(0)
          }} /> */}
          {/* <input name="size" disabled className="xsui-input xsui-input--size-xs xsui-input--appearance-primary" type="text"
          data-value={state['cardWidth'] || ''} defaultValue={state['cardWidth'] || ''} /> */}
          <div className="">{state['cardWidth']}</div>

       </div>

    </div>
  );
}
